// Source: app/scripts/controllers/bank-guarantee.js
/**
 * Created by ristes on 20.4.15.
 */


Auction.controller('BankGuaranteeController', [
  '$scope',
  '$modal',
  '$filter',
  '$location',
  'toaster',
  'crudService',
  'Downloader',
  function ($scope, $modal, $filter, $location, toaster, crudService, Downloader) {

    var BankGuaranteeService = crudService('bank_guarantees', {
      cancel: {
        method: 'POST',
        url: '/data/rest/bank_guarantees/cancel'
      },
      invalidate: {
        method: 'POST',
        url: '/data/rest/bank_guarantees/invalidate'
      },
      markUsed: {
        method: 'POST',
        url: '/data/rest/bank_guarantees/mark_used'
      }
    });

    $scope.cancelEntity = {};

    $scope.modalMarkUsed = $modal({
      scope: $scope,
      template: 'forms/modals/bank_guarantee_mark_used.html',
      show: false
    });
    $scope.modalInvalidate = $modal({
      scope: $scope,
      template: 'forms/modals/bank_guarantee_invalidate.html',
      show: false
    });
    $scope.modalCancel = $modal({
      scope: $scope,
      template: 'forms/modals/bank_guarantee_cancel.html',
      show: false
    });

    $scope.cancelBankGuarantee = function () {
      BankGuaranteeService.cancel({
        id: $scope.cancelEntity.id,
        notes: $scope.cancelEntity.notes
      }, function () {
        delete $scope.cancelEntity.notes;
        delete $scope.cancelEntity.id;
        if ($scope.bankGuaranteeCrud) {
          $scope.bankGuaranteeCrud.clear();
          $scope.bankGuaranteeCrud.reload();
        }
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("CANCELLED"));
        $scope.modalCancel.hide();
      });
    };
    $scope.invalidateBankGuarantee = function () {
      BankGuaranteeService.invalidate({
        id: $scope.cancelEntity.id,
        notes: $scope.cancelEntity.notes
      }, function () {
        delete $scope.cancelEntity.notes;
        delete $scope.cancelEntity.id;
        $scope.bankGuaranteeCrud.clear();
        $scope.bankGuaranteeCrud.reload();
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("INVALID"));
        $scope.modalInvalidate.hide();
      });
    };
    $scope.markUsedBankGuarantee = function () {
      BankGuaranteeService.markUsed({
        id: $scope.cancelEntity.id,
        notes: $scope.cancelEntity.notes
      }, function () {
        delete $scope.cancelEntity.notes;
        delete $scope.cancelEntity.id;
        $scope.bankGuaranteeCrud.clear();
        $scope.bankGuaranteeCrud.reload();
        toaster.pop('success', $filter('translate')('generic.success'),
          $filter('translate')("USED"));
        $scope.modalInvalidate.hide();
      });
    };
    $scope.actions = [{
      text: 'eauction.cancel_bank_guarantee',
      name: 'cancel',
      position: 'right',
      classes: 'btn btn-primary',
      iconClass: 'a fa-fw fa-times',
      enabled: false,
      onClick: function (entity) {
        $scope.cancelEntity.id = entity.id;
        $scope.modalCancel.$promise.then($scope.modalCancel.show);
      }
    }, {
      text: 'eauction.invalidate_bank_guarantee',
      name: 'invalidate',
      position: 'right',
      classes: 'btn btn-primary',
      iconClass: 'fa fa-fw fa-toggle-off',
      enabled: false,
      onClick: function (entity) {
        $scope.cancelEntity.id = entity.id;
        $scope.modalInvalidate.$promise.then($scope.modalInvalidate.show);
      }
    }, {
      text: 'eauction.mark_used_bank_guarantee',
      name: 'markUsed',
      position: 'right',
      classes: 'btn btn-primary',
      iconClass: 'fa fa-fw fa-check-circle',
      enabled: false,
      onClick: function (entity) {
        $scope.cancelEntity.id = entity.id;
        $scope.modalMarkUsed.$promise.then($scope.modalMarkUsed.show);
      }
    }];



    $scope.afterInit = function (crudScope) {

      crudScope.downloadBankGuaranteeAttachment = function (bankGuaranteeId) {
        if(bankGuaranteeId) {
          Downloader.download('/data/rest/portal_attachments/get_bank_guarantee/' + bankGuaranteeId);
        }
      };

    }

  }
]);
